import { constants } from "./Bootstrap";
import $ from "jquery";

export const WebUrl = "https://d1o9dundt2yz9q.cloudfront.net/v1";

export const download_csv = (csv, filename) => {
  var csvFile;
  var downloadLink;
  // CSV FILE
  csvFile = new Blob([csv], { type: "text/csv;charset=utf-8" });

  // Download link
  downloadLink = document.createElement("a");

  // File name
  downloadLink.download = filename;

  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);

  // Make sure that the link is not displayed
  downloadLink.style.display = "none";

  // Add the link to your DOM
  document.body.appendChild(downloadLink);

  // Lanzamos
  downloadLink.click();
};

export const imageURL = (url) => {
  if (url) {
    url = url.split("(").join("%28");
    url = url.split(")").join("%29");
    url = url.split(" ").join("%20");
    url = url.split("@").join("%40");
    url = url.split("!").join("%21");
    url = url.split(",").join("%2C");
    url = url.split("’").join("%E2%80%99");
    url = url.split("‘").join("%E2%80%98");
    url = url.split("'").join("%27");
    url = url.split(";").join("%3B");
    url = url.split("+").join("%20");
    url = url.split("&").join("%26");

    return url;
  } else {
    return "";
  }
};

export const EventArray = [
  { value: "sashaktnari", label: "Sashakt Nari" },
  { value: "swachhbharat", label: "Swachh Bharat" },
  { value: "promotingincredibleindia", label: "Incredible India" },
  { value: "vocalforlocal", label: "Vocal for Local" },
  { value: "digitalpayment", label: "Digital Payment" },
  { value: "videoreel", label: "Video Reel" },
  { value: "media-coverage", label: "Media Coverage" },
  { value: "expandmoment", label: "Expand Moment" },
];

export const export_table_to_csv = (html, filename) => {
  var csv = [];
  var rows = document.querySelectorAll("table tr");

  for (var i = 0; i < rows.length; i++) {
    var row = [],
      cols = rows[i].querySelectorAll("td, th");

    for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);

    csv.push(row.join(","));
  }

  // Download CSV
  download_csv(csv.join("\n"), filename);
};

export const trim = (c) => {
  var ctx = c.getContext("2d"),
    copy = document.createElement("canvas").getContext("2d"),
    pixels = ctx.getImageData(0, 0, c.width, c.height),
    l = pixels.data.length,
    i,
    bound = {
      top: null,
      left: null,
      right: null,
      bottom: null,
    },
    x,
    y;

  for (i = 0; i < l; i += 4) {
    if (pixels.data[i + 3] !== 0) {
      x = (i / 4) % c.width;
      y = ~~(i / 4 / c.width);

      if (bound.top === null) {
        bound.top = y;
      }

      if (bound.left === null) {
        bound.left = x;
      } else if (x < bound.left) {
        bound.left = x;
      }

      if (bound.right === null) {
        bound.right = x;
      } else if (bound.right < x) {
        bound.right = x;
      }

      if (bound.bottom === null) {
        bound.bottom = y;
      } else if (bound.bottom < y) {
        bound.bottom = y;
      }
    }
  }

  var trimHeight = bound.bottom - bound.top;
  if (trimHeight == 0) {
    return false;
  }
  var trimWidth = bound.right - bound.left,
    trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

  copy.canvas.width = trimWidth;
  copy.canvas.height = trimHeight;
  copy.putImageData(trimmed, 0, 0);

  // open new window with trimmed image:
  return copy.canvas;
};

/* Utility function to convert a canvas to a BLOB */
export const dataURLToBlob = function (dataURL) {
  var BASE64_MARKER = ";base64,";
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    var parts = dataURL.split(",");
    var contentType = parts[0].split(":")[1];
    var raw = parts[1];

    return new Blob([raw], { type: contentType });
  }

  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(":")[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

export const parseURLParams = (url) => {
  var queryStart = url.indexOf("?") + 1,
    queryEnd = url.indexOf("#") + 1 || url.length + 1,
    query = url.slice(queryStart, queryEnd - 1),
    pairs = query.replace(/\+/g, " ").split("&"),
    parms = {},
    i,
    n,
    v,
    nv;

  if (query === url || query === "") return;

  for (i = 0; i < pairs.length; i++) {
    nv = pairs[i].split("=", 2);
    n = decodeURIComponent(nv[0]);
    v = decodeURIComponent(nv[1]);

    if (!parms.hasOwnProperty(n)) parms[n] = [];
    parms[n].push(nv.length === 2 ? v : null);
  }
  return parms;
};

export const doRequest = (path, payload, async) => {
  var apiUrl = constants.apiUrl;

  var data = JSON.stringify(payload);

  var xhr = new XMLHttpRequest();

  xhr.open("POST", apiUrl + path, async);
  try {
    xhr.onerror = function (e) {
      window.location.href = constants.loginUrl;
    };
  } catch (error) {
    console.log(error);
  }
  xhr.setRequestHeader("content-type", "application/json");
  xhr.setRequestHeader("Authorization", localStorage.getItem("id_token"));
  xhr.send(data);
  xhr.onreadystatechange = function () {
    if (xhr.readystate == 4) {
      //alert( 'invalid session' );
      if (xhr.status === 200) {
        //  console.log( oXHR.responseText )
      } else {
        window.location.href = constants.loginUrl;
      }
    }
  };

  return xhr;
};

export const AjaxRequest = (payload) => {
  var settings = {
    //  "async": false,
    url: "https://a7mgclqse5.execute-api.ap-south-1.amazonaws.com/NMCampaignCMS/cms-operations",
    method: "POST",
    beforeSend: function (request) {
      request.setRequestHeader(
        "Authorization",
        localStorage.getItem("id_token")
      );
    },
    processData: false,
    data: JSON.stringify(payload),
  };

  var req = $.ajax(settings);
  return req;
};

export const showlist = async ({ data, method, action }) => {
  var requestOptions = {
    method: method ? method : "POST",
    redirect: "follow",
  };
  if (!method) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    requestOptions["body"] = JSON.stringify(data);
    requestOptions["headers"] = myHeaders;
  }

  let response = await fetch(`${WebUrl}/${action}`, requestOptions);
  let jsonResponse = await response.json();
  return jsonResponse;
};

export const updateReq = async (data) => {
  var data = JSON.stringify(data);

  var xhr = new XMLHttpRequest();

  xhr.open("POST", `${WebUrl}/motherhood/update`);

  try {
    xhr.onerror = function (e) {
      window.location.href = constants.loginUrl;
    };
  } catch (error) {
    console.log(error);
  }
  xhr.setRequestHeader("content-type", "application/json");
  xhr.send(data);
  xhr.onreadystatechange = function () {
    if (xhr.readystate === 4) {
      if (xhr.status === 200) {
      } else {
        window.location.href = constants.loginUrl;
      }
    }
  };
  return xhr;
};



// WEBPACK FOOTER //
// ./src/helper.jsx